/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { SoftwareBacklogConfigProviderEntryEntrypointProps } from './SoftwareBacklogConfigProviderEntry.entrypoint.types.tsx';

type SoftwareBacklogConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	SoftwareBacklogConfigProviderEntryEntrypointProps,
	{} | null
>;

export const softwareBacklogConfigProviderEntrypoint: EntryPoint<
	SoftwareBacklogConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<SoftwareBacklogConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-software-backlog-config-provider" */ './SoftwareBacklogConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
